module.exports = __webpack_public_path__ + "img/活动管理.eabede7b.svg";